const React = require('react');
const { Pill } = require('@andes/badge');
const Tag = require('@andes/tag');
const Message = require('@andes/message');
// const Dropdown = require('@andes/dropdown');
const CopyToClipboard = require('react-copy-to-clipboard');
const Copy20 = require('@andes/icons/Copy20');

// const { DropdownStandalone, DropdownItem } = Dropdown;

const APIDetails = ({ apiData, apiMethod, apiEndpoint, i18n, lang, setApiSnackbar, serverEndpoint }) => {
  const concatenateUrl = (api) => {
    try {
      if (api) {
        const url = serverEndpoint + api;
        return url;
      }
      return api;
    } catch (error) {
      console.error('Error when concatenating the URL:', error.message);
      return null;
    }
  };

  return (
    <div>
      <div className="api-session-title">
        <div className="api-title-space">
          <span className="api-title">
            {apiData?.title?.[lang]}
            { apiData.deprecated
          && (
          <Pill className="deprecated-badge" color="red" size="small">
            {i18n.gettext('deprecada').toUpperCase()}
          </Pill>
          )}
          </span>
        </div>
        {/* <div className="api-dropdown-space">
          <DropdownStandalone
            defaultOpen={false}
            defaultValue={1}
            disabled
            id="dropdown-id"
            label=""
            srLabel=""
          >
            <DropdownItem
              title="v2 (atual)"
              value="1"
            />
          </DropdownStandalone>
        </div> */}
      </div>

      <div className={`api-details session-method session-method__${apiMethod}`}>
        <Pill className={`method method__${apiMethod}`}>{apiMethod.toUpperCase()}</Pill>
        <span className="endpoint">{concatenateUrl(apiEndpoint)}</span>

        <div className="session-copy">
          <CopyToClipboard
            text={concatenateUrl(apiEndpoint)}
            onCopy={() => {
              setApiSnackbar(prev => ({
                ...prev,
                snackbarData: {
                  show: true,
                  message: i18n.gettext('Copiado con éxito.'),
                  type: 'success',
                  delay: 3000,
                },
              }));
            }}
          >
            <div className="api-copy">
              <Copy20 color="rgba(0, 0, 0, 0.25)" />
            </div>
          </CopyToClipboard>
        </div>
      </div>
      <span className="api-description">{`${apiData?.description?.[lang]}.`}</span>
      {apiData.deprecated
        && (
        <Message hierarchy="quiet" color="red" title={i18n.gettext('Importante')}>
          <p>
            {i18n.gettext('La API de {0} está obsoleta, te recomendamos no utilizarla', apiData?.title?.[lang])}.
          </p>
          <p className="depecrated-message">
            {i18n.gettext('Para conocer otras opciones, contacta a')}
            <a href={`/developers/${lang}/support/contact`}>{` ${i18n.gettext('soporte')}.`}</a>
          </p>
        </Message>
        )}

      <div className="api-related">
        <span className="api-related--title">{i18n.gettext('Productos que lo utilizan')}:</span>
        <div className="api-related--tags">
          {apiData.tags.map((tag) => (
            <a href={`/developers/${lang}${tag?.externalDocs?.url}`} target="_blank" rel="noreferrer">
              <Tag label={tag?.description[lang]} className="tag" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

module.exports = APIDetails;
